export async function Channels(token: string | null) {
    
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/channels',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }

    const request = await axios.request(options);
    return request;
}

export async function ChangeChannel(token: string | null, channel) {

  const axios = require('axios');

  let value = JSON.stringify(channel);

  const options = {
      method: 'POST',
      url: process.env.REACT_APP_HOST + 'api/channels',
      headers: {
          Authorization: "Bearer " + token, 
          "Content-Type": "application/json",
          Accept: "application/json",
      },
      data:
      {
          value
      },
  };

  const request = await axios.request(options);
  return request;
}